interface Props {
  [key: string]: any
}

export default function CopyIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" {...rest} viewBox="0 0 11 12" xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M10.4807 0.953812H3.29161C3.17244 0.953812 3.05815 1.00115 2.97389 1.08541C2.88962 1.16968 2.84229 1.28396 2.84229 1.40313V3.64973H0.595683C0.476516 3.64973 0.362229 3.69707 0.277965 3.78134C0.193701 3.8656 0.146362 3.97989 0.146362 4.09905V11.2882C0.146362 11.4073 0.193701 11.5216 0.277965 11.6059C0.362229 11.6902 0.476516 11.7375 0.595683 11.7375H7.78481C7.90398 11.7375 8.01826 11.6902 8.10253 11.6059C8.18679 11.5216 8.23413 11.4073 8.23413 11.2882V9.04158H10.4807C10.5999 9.04158 10.7142 8.99424 10.7985 8.90998C10.8827 8.82571 10.9301 8.71143 10.9301 8.59226V1.40313C10.9301 1.28396 10.8827 1.16968 10.7985 1.08541C10.7142 1.00115 10.5999 0.953812 10.4807 0.953812ZM7.33549 10.8389H1.045V4.54838H7.33549V10.8389ZM10.0314 8.14294H8.23413V4.09905C8.23413 3.97989 8.18679 3.8656 8.10253 3.78134C8.01826 3.69707 7.90398 3.64973 7.78481 3.64973H3.74093V1.85245H10.0314V8.14294Z"
        fill="white"
      />
    </svg>
  )
}
